import jwtAuthAxios from "./auth/jwtAuth";

const sellerServices = {};

sellerServices.search = async () => {
  const { data } = await jwtAuthAxios.get('/sellers');
  return data;
};

export default sellerServices;
